import {
  attributionCookieDomain,
  readCookieValue,
} from "@tabbio/utils/analytics/attribution";
import {
  POSTHOG_SESSION_COOKIE,
  SESSION_IDLE_MS,
} from "@tabbio/utils/analytics/browser-session";

export function measurementCookieStorage(browser: {
  hostname(): string;
  secure(): boolean;
  read(): string;
  write(value: string): void;
}) {
  const writeCookie = (name: string, value: string | null, maxAge: number) => {
    const domain = attributionCookieDomain(browser.hostname());
    browser.write(
      `${name}=${value === null ? "" : encodeURIComponent(value)}; Path=/; Max-Age=${value === null ? 0 : maxAge}; SameSite=Lax${domain ? `; Domain=${domain}` : ""}${browser.secure() ? "; Secure" : ""}`,
    );
  };
  return {
    read: () => readCookieValue(browser.read(), POSTHOG_SESSION_COOKIE),
    write: (value: string | null) =>
      writeCookie(POSTHOG_SESSION_COOKIE, value, SESSION_IDLE_MS / 1000),
    writeCookie,
  };
}

/** An explicit operator/test marker, never inferred from IP ranges or user role. */
export function analyticsTrafficType(
  cookieHeader: string,
): "internal" | "test" | undefined {
  const value = readCookieValue(cookieHeader, "tabbio_traffic_type");
  return value === "internal" || value === "test" ? value : undefined;
}
export function analyticsTrafficProperties(cookieHeader: string): Record<string, string | boolean> {
  const type = analyticsTrafficType(cookieHeader);
  return type
    ? { traffic_type: "internal", test_traffic: type === "test" }
    : {};
}
